type Device = 'mobile' | 'tablet' | 'laptop' | 'desktop';

const size: Record<Device, string> = {
  mobile: '40rem',
  tablet: '48rem',
  laptop: '64rem',
  desktop: '86rem'
};

const rootFontSizePx = 16;

export function breakpointsMin(device: Device) {
  if (device == 'mobile') {
    return `(min-width: ${size.mobile})`;
  }
  if (device == 'tablet') {
    return `(min-width: ${size.tablet})`;
  }
  if (device == 'laptop') {
    return `(min-width: ${size.laptop})`;
  }
  if (device == 'desktop') {
    return `(min-width: ${size.desktop})`;
  }
  throw new Error(`Breakpont device is not defined: ${device}`);
}

export function breakpointsMax(device: Extract<Device, 'mobile' | 'tablet'>) {
  if (device == 'mobile') {
    return `(max-width: ${size.tablet})`;
  }
  if (device == 'tablet') {
    return `(max-width: ${size.desktop})`;
  }
  throw new Error(`Breakpont device is not defined: ${device}`);
}

export function breakpointsInPx(device: Device) {
  const sizeRem = size[device];
  const sizeRemNum = parseInt(sizeRem.replace('rem', ''));
  return sizeRemNum * rootFontSizePx;
}
